import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Contrato } from '../modelos/contrato';
import { Filtro } from '../paginas/transparencia/contratos-empenho/contratos/contratos.component';
import { ApiConfig, Path, SiteAdmApiConfig } from '../util/path';
import {PaginaSetorInterno} from "../modelos/paginaNucleo";

@Injectable({
  providedIn: 'root'
})
export class PaginaNucleoService {

  private token: String;

  constructor(private httpClient: HttpClient) {
    this.token = ApiConfig.API_TOKEN;
  }

  private getCabecalho() {
    let cabecalho = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //'Authorization': 'Bearer ' + this.token,
      })
    };
    return cabecalho;
  }


  buscarPaginaPorId(id: String): Observable<PaginaSetorInterno >{
    let url = Path.URL_REQUISICAO.caminho + `/${id}`;
    return this.httpClient.get<PaginaSetorInterno>(url, this.getCabecalho());
  }
}
